import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import UserRoutes from "./routes/UserRoutes";
import AdminRoutes from "./routes/AdminRoutes";
import { useLanguage } from "./hooks/UseLanguage";

const App: React.FC = () => {

  const { direction } = useLanguage();

  return (
    <ConfigProvider direction={direction}>
      <Router>
        <Routes>
          {/* ✅ User side (includes Notification + Menu context + SessionChecker inside) */}
          <Route path="/*" element={<UserRoutes />} />

          {/* ✅ Admin Portal - clean and separate, no user context or session check */}
          <Route path="/admin-portal/*" element={<AdminRoutes />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
